/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@ba-ui-toolkit/button';
import { classnames as cx, propsUtils } from '@ba-ui-toolkit/utils';
import styles from './PushButton.scss';

const pushButtonClassName = styles.pushButtonClassName.replace(/"/g, '');
const { sanitize, getInheritedProps } = propsUtils;

export default class PushButton extends Component {
	static propTypes = {
		...Button.propTypes,
		checked: PropTypes.bool,
		onClick: PropTypes.func,
		onChange: PropTypes.func,
		disabled: PropTypes.bool,
		className: PropTypes.string,
		style: PropTypes.object,
	};

	static defaultProps = {
		checked: false,
		className: '',
		style: {},
	};

	focus() {
		this._button && this._button.focus();
	}

	_ref = button => {
		this._button = button;
	};

	_onClick = e => {
		const { onChange, checked, onClick } = this.props;
		onChange && onChange(!checked);
		onClick && onClick(e);
	};

	render() {
		const { checked, disabled, className, style, ...others } = this.props;
		const classNames = cx(pushButtonClassName, {
			checked,
		});
		const buttonPassthroughProps = getInheritedProps(others, Button);

		return (
			<span className={`${classNames} ${className}`} style={style}>
				<Button
					data-tid="ba-common-push-button__button"
					{...sanitize(others, PushButton)}
					{...buttonPassthroughProps}
					role="checkbox"
					ref={this._ref}
					aria-checked={checked}
					onClick={this._onClick}
					disabled={disabled}
				/>
			</span>
		);
	}
}
